import axios, { AxiosInstance } from 'axios';
// import { Auth } from '@/modules/auth/types';
import { ResponseStatuses, ResponseFailStatusesTranslate } from '@/enums';
import { update_token } from '@/services/keycloak-service';
import Vue from 'vue';
import { BtnsPosition } from '@/components/dialogs/simple/types';
import { User } from '@/modules/user/types/';

export class BaseApiService {
  /**
   * HTTP клиент для работы с API
   * @type { AxiosInstance }
   */
  protected readonly http_client: AxiosInstance;

  /**
   * Список URL для которых можно использовать cancel token
   * @type { string[] }
   */
  public cancel_token_urls: string[] = [];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private cancel_request: any = undefined;

  constructor() {
    this.http_client = axios.create();
    const { CancelToken } = axios;

    this.http_client.interceptors.request.use(
      async (req) => {
        const r = req;
        const token = await update_token();
        const { user_type } = Vue;

        r.baseURL = this.apiUrl();

        if (!r.timeout) {
          r.timeout = 30000;
        }

        const is_canceled = this.cancel_token_urls.some((el) => r.url?.includes(el));

        if (is_canceled) {
          if (this.cancel_request !== undefined) {
            this.cancel_request();
          }

          r.cancelToken = new CancelToken((c: unknown) => {
            this.cancel_request = c;
          });
        }

        /**
         * методы PATCH и DELETE в Laravel
         * сделан как POST с указанием _method=patch/delete в url
         */
        if (r.method === 'patch' || r.method === 'PATCH') {
          r.method = 'POST';
          r.url = `${r.url}?_method=patch`;
        }

        if (r.method === 'delete' || r.method === 'DELETE') {
          r.method = 'POST';
          r.url = `${r.url}?_method=delete`;
        }

        if (r.headers && token) {
          r.headers.Authorization = `Bearer ${token}`;
        }

        if (r.headers && user_type) {
          r.headers.Keycloak = `${Vue.user_type}`;
        }

        return r;
      },
      (err) => Promise.reject(err),
    );

    this.http_client.interceptors.response.use(
      (res) => res,
      (err) => {
        if (axios.isCancel(err)) {
          console.log(err);
          // return Promise.reject(new Error('token has been canceled'));
          return Promise.reject(new Error('request has been canceled'));
        }

        if (err?.response?.status === ResponseStatuses.Fail.UNAUTHORIZED) {
          // TODO: придумать как выпилить и сделать через router + vuex !!!1
          // localStorage.removeItem(Auth.TokenPrefix.JWT);
          // window.location.replace(Auth.Pages.SIGN_IN);

          // logout using keycloak
          Vue.dialog.open({
            title: ResponseFailStatusesTranslate[ResponseStatuses.Fail.UNAUTHORIZED],
            text: err.response?.data?.message,
            center_title: true,
            center_text: true,
            bts_align: BtnsPosition.CENTER,
          });
          Vue.dialog.on_close(() => {
            Vue.keycloak_instance.logout();
          });
        }

        if (err?.response?.status === ResponseStatuses.Fail.FORBIDDEN) {
          Vue.dialog.open({
            title: ResponseFailStatusesTranslate[ResponseStatuses.Fail.FORBIDDEN],
            text: err.response?.data?.message,
            center_title: true,
            center_text: true,
            bts_align: BtnsPosition.CENTER,
          });
          Vue.dialog.on_close(() => {
            window.location.replace(`${window.location.origin}/${User.Pages.PROFILE}`);
          });
        }

        if (err?.response?.status === ResponseStatuses.Fail.NOT_FOUND) {
          Vue.dialog.open({
            title: ResponseFailStatusesTranslate[ResponseStatuses.Fail.NOT_FOUND],
            text: err.response?.data?.message,
            center_title: true,
            center_text: true,
            bts_align: BtnsPosition.CENTER,
          });
          // Vue.dialog.on_close(() => {
          //   if (err?.response?.config?.baseURL === window.location.href) {
          //     window.history.go(-1);
          //   }
          // });
        }

        if (err?.response?.status === ResponseStatuses.Fail.INTERNAL_ERROR && !err?.config?.skipInternalError) {
          Vue.dialog.open({
            title: ResponseFailStatusesTranslate[ResponseStatuses.Fail.INTERNAL_ERROR],
            text: 'На сервере произошла непредвиденная ошибка. Пожалуйста, подождите. Она вскоре будет исправлена.',
            center_title: true,
            center_text: true,
            bts_align: BtnsPosition.CENTER,
          });
        }

        if (err?.response?.status === ResponseStatuses.Fail.UNPROCESSABLE) {
          Vue.dialog.open({
            title: ResponseFailStatusesTranslate[ResponseStatuses.Fail.UNPROCESSABLE],
            text: err.response?.data?.message || 'Некорректное значение',
            center_title: true,
            center_text: true,
            bts_align: BtnsPosition.CENTER,
          });
        }

        if (err.response) {
          return Promise.reject(err.response);
        }
        // return Promise.reject(err.response);
        return Promise.reject(err);
      },
    );
  }

  private readonly api_version = 'v1';

  protected apiUrl(version = this.api_version): string {
    const is_dev = process.env.NODE_ENV === 'development';

    return is_dev
      ? `${window.env.VUE_APP_API_URL}${version}/`
      : `https://${window.location.hostname}/api/${version}/`;
  }
}
